import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import { range } from 'lodash';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Table from './table';
/**
 * `TablePlaceholder` behaves like `Table` but displays placeholder boxes instead of data. This can be used while loading.
 */

var TablePlaceholder =
/*#__PURE__*/
function (_Component) {
  _inherits(TablePlaceholder, _Component);

  function TablePlaceholder() {
    _classCallCheck(this, TablePlaceholder);

    return _possibleConstructorReturn(this, _getPrototypeOf(TablePlaceholder).apply(this, arguments));
  }

  _createClass(TablePlaceholder, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          numberOfRows = _this$props.numberOfRows,
          tableProps = _objectWithoutProperties(_this$props, ["numberOfRows"]);

      var rows = range(numberOfRows).map(function () {
        return _this.props.headers.map(function () {
          return {
            display: createElement("span", {
              className: "is-placeholder"
            })
          };
        });
      });
      return createElement(Table, _extends({
        ariaHidden: true,
        classNames: "is-loading",
        rows: rows
      }, tableProps));
    }
  }]);

  return TablePlaceholder;
}(Component);

TablePlaceholder.propTypes = {
  /**
   *  An object of the query parameters passed to the page, ex `{ page: 2, per_page: 5 }`.
   */
  query: PropTypes.object,

  /**
   * A label for the content in this table.
   */
  caption: PropTypes.string.isRequired,

  /**
   * An array of column headers (see `Table` props).
   */
  headers: PropTypes.arrayOf(PropTypes.shape({
    hiddenByDefault: PropTypes.bool,
    defaultSort: PropTypes.bool,
    isSortable: PropTypes.bool,
    key: PropTypes.string,
    label: PropTypes.node,
    required: PropTypes.bool
  })),

  /**
   * An integer with the number of rows to display.
   */
  numberOfRows: PropTypes.number
};
TablePlaceholder.defaultProps = {
  numberOfRows: 5
};
export default TablePlaceholder;
//# sourceMappingURL=placeholder.js.map